// extracted by mini-css-extract-plugin
module.exports = {"svgWrapper":"MoonIcon_svgWrapper__2RtZX","svg":"MoonIcon_svg__1HPy-"};